const postsDanish = {
  header: {
    title: "Mine LinkedIn Opslag",
    postsLeft: "{remaining}/{limit} opslag tilbage denne uge"
  },
  limitWarning: {
    used: "Du har opbrugt dine {limit} ugentlige opslag. Opgrader dit abonnement for at få flere.",
    upgrade: "Opgrader abonnement",
    low: "Du har {remaining} opslag tilbage denne uge. Planlæg dem med omhu."
  },
  loading: "Indlæser opslag...",
  noPostsMessage: {
    title: "Ingen planlagte opslag",
    help: "Brug Telegram botten til at planlægge nye opslag"
  },
  postCard: {
    date: "{date}",
    time: "{time}",
    status: {
      scheduled: "Planlagt",
      published: "Publiceret"
    },
    image: "Billede vedlagt",
    actions: {
      share: "Del på LinkedIn",
      sharing: "Deler...",
      delete: "Slet",
      deleting: "Sletter..."
    }
  },
  confirmation: {
    delete: "Er du sikker på, at du vil slette dette opslag?"
  },
  result: {
    success: "Opslag delt på LinkedIn!",
    errorPrefix: "Fejl: ",
    postDeleted: "Opslag slettet!"
  },
  customerBanner: "Du ser opslag for {customerName}",
  calendar: {
    viewToggle: {
      month: "Måned",
      week: "Uge"
    },
    weekDays: {
      sunday: "Søndag",
      monday: "Mandag", 
      tuesday: "Tirsdag",
      wednesday: "Onsdag",
      thursday: "Torsdag",
      friday: "Fredag",
      saturday: "Lørdag"
    },
    weekHeader: "Uge {week} - {month} {year}",
    noTime: "Ingen tid"
  },
  modal: {
    title: "Opslag detaljer",
    sections: {
      content: "Indhold",
      schedule: "Planlagt tidspunkt",
      status: "Status",
      image: "Billede"
    },
    schedule: {
      noTime: "Ingen tid planlagt",
      edit: "Ændr",
      date: "Dato",
      time: "Tid",
      cancel: "Fortryd",
      save: "Gem"
    },
    status: {
      published: "Udgivet",
      ready: "Klar til udgivelse", 
      scheduled: "Planlagt",
      unknown: "Ukendt"
    },
    actions: {
      delete: "Slet opslag",
      share: "Del på LinkedIn"
    }
  }
};

export default postsDanish; 